export var CollectionHistoryEventType;
(function (CollectionHistoryEventType) {
    CollectionHistoryEventType["Created"] = "CREATED";
    CollectionHistoryEventType["Edited"] = "EDITED";
    CollectionHistoryEventType["SoftDeleted"] = "SOFT_DELETED";
    CollectionHistoryEventType["Restored"] = "RESTORED";
    CollectionHistoryEventType["Deleted"] = "DELETED";
})(CollectionHistoryEventType || (CollectionHistoryEventType = {}));
export var CollectionHistoryUserType;
(function (CollectionHistoryUserType) {
    CollectionHistoryUserType["Investor"] = "investor";
    CollectionHistoryUserType["AdminUser"] = "adminUser";
    CollectionHistoryUserType["OrgUser"] = "orgUser";
    CollectionHistoryUserType["Adviser"] = "adviser";
})(CollectionHistoryUserType || (CollectionHistoryUserType = {}));
export * as Api from './api';
//# sourceMappingURL=index.js.map